export const setSelectedApprovedAreas = approvedAreas => ({
  type: 'SET_SELECTED_APPROVED_AREAS',
  payload: approvedAreas,
});
